import { useEffect, useRef, useState } from "react";
import { ChevronDown, Search, Plane } from "lucide-react";
import { AIRPORTS } from "../data/airports";

export default function AirportPicker({ value, onChange, label, placeholder, testid }) {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState("");
  const wrapRef = useRef(null);

  useEffect(() => {
    const onDoc = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, []);

  const selected = AIRPORTS.find((a) => a.code === value);
  const q = query.trim().toLowerCase();
  const list = q
    ? AIRPORTS.filter(
        (a) =>
          a.code.toLowerCase().includes(q) ||
          a.city.toLowerCase().includes(q) ||
          a.country.toLowerCase().includes(q)
      )
    : AIRPORTS;

  return (
    <div className="gd-dropdown" ref={wrapRef}>
      <label className="gd-label">{label}</label>
      <button
        type="button"
        className="gd-input"
        data-testid={testid}
        onClick={() => setOpen((v) => !v)}
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          textAlign: "left",
          cursor: "pointer",
        }}
      >
        <span style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <Plane size={16} color="#6B7280" />
          {selected ? (
            <span>
              <strong style={{ fontWeight: 600 }}>{selected.city}</strong>{" "}
              <span style={{ color: "#6B7280", fontSize: 13, marginLeft: 6 }}>
                {selected.code} · {selected.country}
              </span>
            </span>
          ) : (
            <span style={{ color: "#9ca3af" }}>{placeholder || "Select airport"}</span>
          )}
        </span>
        <ChevronDown size={16} color="#6B7280" />
      </button>

      {open && (
        <div className="gd-dropdown-list" data-testid={`${testid}-list`}>
          <div style={{ padding: 10, borderBottom: "1px solid var(--border)", position: "sticky", top: 0, background: "#fff" }}>
            <div style={{ position: "relative" }}>
              <Search
                size={14}
                color="#6B7280"
                style={{ position: "absolute", left: 10, top: "50%", transform: "translateY(-50%)" }}
              />
              <input
                autoFocus
                className="gd-input"
                style={{ paddingLeft: 32, padding: "10px 10px 10px 32px" }}
                placeholder="Search city or IATA code"
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                data-testid={`${testid}-search`}
              />
            </div>
          </div>
          {list.length === 0 && (
            <div style={{ padding: 16, color: "#6B7280", fontSize: 13 }}>No airports found.</div>
          )}
          {list.map((a) => (
            <div
              key={a.code}
              className={`gd-dropdown-item ${value === a.code ? "active" : ""}`}
              onClick={() => {
                onChange(a.code);
                setOpen(false);
                setQuery("");
              }}
              data-testid={`${testid}-option-${a.code}`}
            >
              <span>
                <strong style={{ fontWeight: 600 }}>{a.city}</strong>{" "}
                <span style={{ color: "#6B7280", fontSize: 12, marginLeft: 6 }}>
                  {a.name}, {a.country}
                </span>
              </span>
              <span style={{ color: "#111827", fontSize: 12, fontWeight: 600, letterSpacing: 0.5 }}>
                {a.code}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
